<template>
          <v-dialog v-model="showConfirm" persistent max-width="500" style="z-index:20099;">
          <v-card>
            <v-card-title class="headline">{{title}}</v-card-title>
            <v-card-text>{{message}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="doConfirmAddingEmployees">{{titleOkWithEmployee}}</v-btn>
              <v-btn color="secondary" text @click="doConfirmNoAdditionOfEmployees">{{titleOk}}</v-btn>
              <v-btn v-if="!!titleCancel" text @click="doCancel">{{titleCancel}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
</template>

<script>
 
  export default {
    name: 'InfoPlanningAssistantDialog', 
    props: ['message','titleOkWithEmployee','titleOk','titleCancel','title'],
    data(){
        return { 
             payload:null,
             showConfirm: false
        }

    },  
    methods: {
        confirm(payload)
        { 
            this.payload=payload;
            this.showConfirm=true;
        }
        ,
        doConfirmAddingEmployees()
        {
            this.showConfirm = false;
            this.$emit('confirmedAddEmployees',this.payload);
        },
        doConfirmNoAdditionOfEmployees()
        {
          this.showConfirm = false;
          this.$emit('confirmed', this.payload);
        },
        doCancel()
        {
            this.showConfirm = false;
            this.$emit('canceled',this.payload);
        }
      },
  }
</script>